"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationLogApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var OperationLogApi = /** @class */ (function () {
    function OperationLogApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 查询操作日志
     * @method GET 查询操作日志
     *
     */
    OperationLogApi.prototype.OperationLog = function () {
        return this.http
            .url("/api/OperationLog")
            .addSecurityHeaders()
            .support('GET');
    };
    OperationLogApi.diOptions = di_1.default.options({
        name: "OperationLogApi",
        scope: "Singleton"
    });
    return OperationLogApi;
}());
exports.OperationLogApi = OperationLogApi;
exports.default = OperationLogApi;
